import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import React from 'react';
import { AccountData, ResourceHoldData } from '../../../../../api';
import { useAuth } from '../../../../../session/InternalAuthProvider';
import { useLanguage } from '../../../../../common/GeneralUtils';
import { resourceShortName } from '../../../../../utils/maskUtils';

type SeatingPanelSummaryProps = {
  showTables: boolean;
  selectedHolds: ResourceHoldData[];
  scheduledIndexes: number[];
  orderPageId?: string;
  skipResourceAssignment: boolean;
  resourceOptionLabel?: string;
};
export const SeatingPanelSummary = ({
  showTables,
  selectedHolds,
  scheduledIndexes,
  orderPageId,
  skipResourceAssignment,
  resourceOptionLabel,
}: SeatingPanelSummaryProps) => {
  const { t } = useTranslation();
  const language = useLanguage();
  const { authState } = useAuth();
  const configs = (authState.account as unknown as AccountData).shared_resources?.scheduler_configs ?? [];
  const pageConfig = configs.find((config) => config.allowed_masks?.some((mask) => mask.order_page_id === orderPageId));

  const chosenNames = selectedHolds.flatMap((hold) =>
    hold.resource_indexes.map((index) =>
      resourceShortName(
        index,
        configs.find((config) => config.id === hold.scheduler_config_id),
        language,
      ),
    ),
  );
  const scheduledNames = scheduledIndexes.map((index) => resourceShortName(index, pageConfig, language));

  let tablesText = t('calendar.edit_order.seating.automatic');
  if (skipResourceAssignment) {
    tablesText = t('calendar.edit_order.seating.withoutTable');
  } else if (chosenNames.length > 0) {
    tablesText = chosenNames.join(', ');
  } else if (scheduledNames.length > 0) {
    tablesText = scheduledNames.join(', ');
  }

  return (
    <Grid container direction="column" gap={0.5}>
      {showTables && (
        <Grid container gap={0.5} wrap="nowrap">
          <Typography variant="body1" color="text.secondary">
            {t('calendar.edit_order.seating.tables')}
          </Typography>
          <Typography variant="body1" noWrap sx={{ flex: 1, minWidth: 0 }}>
            {tablesText}
          </Typography>
        </Grid>
      )}
      {resourceOptionLabel && (
        <Grid container gap={0.5} wrap="nowrap">
          <Typography variant="body1" color="text.secondary">
            {t('calendar.edit_order.resourceOption')}
          </Typography>
          <Typography variant="body1" noWrap sx={{ flex: 1, minWidth: 0 }}>
            {resourceOptionLabel}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
